import {
  apiClient,
} from "./apiClient";

import type {
  AccountUpgradeRequestActionData,
  AccountUpgradeRequestDetailsData,
  AccountUpgradeRequestsListData,
  AccountUpgradeRequestsQuery,
  ApproveAccountUpgradeRequestInput,
  RejectAccountUpgradeRequestInput,
  UserAccountLogsData,
} from "../types/account-upgrade-requests.types";

function buildQuery<
  T extends object
>(
  query: T,
): string {
  const params =
    new URLSearchParams();

  Object.entries(
    query,
  ).forEach(
    ([
      key,
      value,
    ]) => {
      if (
        value ===
          undefined ||
        value ===
          null ||
        value ===
          ""
      ) {
        return;
      }

      params.set(
        key,
        String(
          value,
        ),
      );
    },
  );

  const queryString =
    params.toString();

  return queryString
    ? `?${queryString}`
    : "";
}

export const accountUpgradeRequestsApi = {
  /**
   * =========================================================
   * GET /accounts/upgrade-requests
   * =========================================================
   */

  list(
    query:
      AccountUpgradeRequestsQuery =
        {},
  ) {
    return apiClient.get<
      AccountUpgradeRequestsListData
    >(
      `/accounts/upgrade-requests${buildQuery(
        query,
      )}`,
    );
  },

  /**
   * =========================================================
   * GET /accounts/upgrade-requests/:requestId
   * =========================================================
   */

  getById(
    requestId: string,
  ) {
    return apiClient.get<
      AccountUpgradeRequestDetailsData
    >(
      `/accounts/upgrade-requests/${encodeURIComponent(
        requestId,
      )}`,
    );
  },

  /**
   * =========================================================
   * POST /accounts/upgrade-requests/:requestId/approve
   * =========================================================
   */

  approve(
    requestId: string,
    input:
      ApproveAccountUpgradeRequestInput =
        {},
  ) {
    return apiClient.post<
      AccountUpgradeRequestActionData
    >(
      `/accounts/upgrade-requests/${encodeURIComponent(
        requestId,
      )}/approve`,
      input,
    );
  },

  /**
   * =========================================================
   * POST /accounts/upgrade-requests/:requestId/reject
   * =========================================================
   */

  reject(
    requestId: string,
    input:
      RejectAccountUpgradeRequestInput,
  ) {
    return apiClient.post<
      AccountUpgradeRequestActionData
    >(
      `/accounts/upgrade-requests/${encodeURIComponent(
        requestId,
      )}/reject`,
      input,
    );
  },

  /**
   * =========================================================
   * GET /users/:uid/account-logs
   * =========================================================
   */

  getUserLogs(
    uid: string,
    limit = 50,
  ) {
    return apiClient.get<
      UserAccountLogsData
    >(
      `/users/${encodeURIComponent(
        uid,
      )}/account-logs${buildQuery(
        {
          limit,
        },
      )}`,
    );
  },
};